/* Covenant Craft gift pop-up: email -> Klaviyo list -> scratch card -> gift. Generated by shared-store/2026-10-06-giftpop/gen.py. */
(function () {
  var P = 'cc', root = document.getElementById(P + 'gp'), tab = document.getElementById(P + 'gp-tab');
  if (!root) return;
  var KEY = P + '_giftpop', d = root.dataset, qs = new URLSearchParams(location.search), force = qs.get('giftpop');
  var $ = function (s) { return root.querySelector(s); };
  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
    set: function (o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  };
  if (force === 'reset') { try { localStorage.removeItem(KEY); } catch (e) {} }
  var state = store.get(), opened = false, lastFocus = null;
  var stepEmail = $('[data-step=email]'), stepScratch = $('[data-step=scratch]'), form = $('.' + P + 'gp-form'), err = $('.' + P + 'gp-err');
  var canvas = $('.' + P + 'gp-canvas'), after = $('.' + P + 'gp-after'), revealBtn = $('.' + P + 'gp-reveal'), code = $('.' + P + 'gp-code');

  function show(step) {
    stepEmail.hidden = step !== 'email'; stepScratch.hidden = step === 'email';
    if (step === 'gift') revealed(true);
  }
  function open(step) {
    if (opened) return; opened = true; lastFocus = document.activeElement;
    root.hidden = false; show(step); if (tab) tab.hidden = true;
    document.documentElement.classList.add(P + 'gp-lock');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      if (step === 'email') { var i = form.querySelector('input'); if (i && matchMedia('(hover:hover)').matches) i.focus(); }
      if (step === 'scratch') paint();
    });
  }
  function close() {
    if (!opened) return; opened = false;
    root.classList.remove('is-open'); document.documentElement.classList.remove(P + 'gp-lock');
    setTimeout(function () { root.hidden = true; }, 220);
    state = store.get();
    if (!state.email) { state.snooze = Date.now() + Number(d.snooze || 7) * 864e5; store.set(state); }
    else if (tab) tab.hidden = false;
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-gp-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });
  if (tab) tab.addEventListener('click', function () { open(store.get().revealed ? 'gift' : 'scratch'); });

  /* ---- step 1: email -> Klaviyo (the scratch card unlocks only after Klaviyo accepts it) ---- */
  function fail(msg) { err.textContent = msg; err.hidden = false; form.classList.remove('is-busy'); }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input'), email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return fail('That email does not look right.');
    if (form.classList.contains('is-busy')) return;
    err.hidden = true; form.classList.add('is-busy');
    var props = {}; props[d.prop] = 'yes'; props[P + '_gift_popup'] = 'yes';
    var body = { data: { type: 'subscription', attributes: { custom_source: d.source, profile: { data: { type: 'profile', attributes: {
      email: email, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: d.list } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + d.company, { method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) })
      .then(function (r) {
        if (!r.ok) throw new Error('klaviyo ' + r.status);
        state = store.get(); state.email = 1; state.at = Date.now(); delete state.snooze; store.set(state);
        form.classList.remove('is-busy'); show('scratch'); paint();
      })
      .catch(function () { fail('That did not go through. Please try again.'); });
  });

  /* ---- step 2: scratch card ---- */
  var ctx, cells, hit = 0, COLS = 10, ROWS = 5, done = false, last = null;
  function paint() {
    if (!canvas || done) return;
    var r = canvas.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (!r.width) return;
    canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
    ctx = canvas.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var cs = getComputedStyle(root), a = cs.getPropertyValue('--gp-foil').trim() || '#888', b = cs.getPropertyValue('--gp-foil-2').trim() || '#777';
    ctx.globalCompositeOperation = 'source-over'; ctx.fillStyle = a; ctx.fillRect(0, 0, r.width, r.height);
    ctx.strokeStyle = b; ctx.lineWidth = 6;
    for (var x = -r.height; x < r.width; x += 18) { ctx.beginPath(); ctx.moveTo(x, r.height); ctx.lineTo(x + r.height, 0); ctx.stroke(); }
    ctx.fillStyle = cs.getPropertyValue('--gp-foil-ink').trim() || '#fff';
    ctx.font = '700 ' + Math.max(15, Math.min(22, r.width / 15)) + 'px ' + (cs.getPropertyValue('--gp-display').trim() || 'sans-serif');
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText((canvas.dataset.label || 'Scratch here').toUpperCase(), r.width / 2, r.height / 2);
    cells = new Array(COLS * ROWS); hit = 0;
  }
  function at(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top, w: r.width, h: r.height }; }
  function scratch(p) {
    if (!ctx || done) return;
    ctx.globalCompositeOperation = 'destination-out'; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 40;
    ctx.beginPath(); ctx.moveTo((last || p).x, (last || p).y); ctx.lineTo(p.x + 0.01, p.y + 0.01); ctx.stroke(); last = p;
    var c = Math.floor(p.x / p.w * COLS), r = Math.floor(p.y / p.h * ROWS);
    for (var dc = -1; dc <= 1; dc++) for (var dr = -1; dr <= 1; dr++) {
      var cc = c + dc, rr = r + dr; if (cc < 0 || rr < 0 || cc >= COLS || rr >= ROWS) continue;
      if (!cells[rr * COLS + cc]) { cells[rr * COLS + cc] = 1; hit++; }
    }
    if (hit / (COLS * ROWS) >= 0.55) revealed();
  }
  if (canvas) {
    canvas.addEventListener('pointerdown', function (e) { e.preventDefault(); try { canvas.setPointerCapture(e.pointerId); } catch (x) {} last = null; scratch(at(e)); });
    canvas.addEventListener('pointermove', function (e) { if (e.buttons || e.pointerType === 'touch') scratch(at(e)); });
    canvas.addEventListener('pointerup', function () { last = null; });
    window.addEventListener('resize', function () { if (opened && !stepScratch.hidden && !done && !hit) paint(); });
  }
  if (revealBtn) revealBtn.addEventListener('click', function () { revealed(); });
  function revealed(instant) {
    if (done) return; done = true;
    if (canvas) { canvas.classList.add(instant ? 'is-gone' : 'is-fading'); setTimeout(function () { canvas.classList.add('is-gone'); }, 420); }
    if (revealBtn) revealBtn.hidden = true; if (after) after.hidden = false; if (code) code.tabIndex = 0;
    stepScratch.classList.add('is-revealed');
    state = store.get(); state.email = 1; state.revealed = 1; store.set(state);
  }
  if (code) code.addEventListener('click', function () {
    var t = code.dataset.code, lab = code.querySelector('span');
    var ok = function () { lab.textContent = 'Copied'; setTimeout(function () { lab.textContent = 'Copy'; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(ok, function () {}); else ok();
  });

  /* ---- when it opens ---- */
  if (force === '1') { state = {}; return void setTimeout(function () { open('email'); }, 300); }
  if (d.design) return;
  if (state.email) { if (tab && (!state.at || Date.now() - state.at < 14 * 864e5)) tab.hidden = false; return; }
  if (state.snooze && Date.now() < state.snooze) return;
  var go = function () { if (!opened && !document.querySelector('.drawer.open, .is-cart-open')) open('email'); cleanup(); };
  var timer = setTimeout(go, Number(d.delay || 8) * 1000);
  var onScroll = function () {
    var max = document.documentElement.scrollHeight - innerHeight;
    if (max > 200 && scrollY / max * 100 >= Number(d.scroll || 40)) go();
  };
  function cleanup() { clearTimeout(timer); removeEventListener('scroll', onScroll); }
  addEventListener('scroll', onScroll, { passive: true });
})();
